
import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { formatCurrency } from '@/utils/formatters';

interface RevenueSplitChartProps {
  siteShare: number;
  yourShare: number;
  siteName?: string;
}

const RevenueSplitChart: React.FC<RevenueSplitChartProps> = ({ 
  siteShare, 
  yourShare, 
  siteName = "ReferMe.site" 
}) => {
  const data = [
    { name: `${siteName} (${Math.round(siteShare/(siteShare+yourShare)*100)}%)`, value: siteShare },
    { name: `Your Share (${Math.round(yourShare/(siteShare+yourShare)*100)}%)`, value: yourShare }
  ];

  const COLORS = ['#3B82F6', '#10B981'];

  return (
    <div className="h-64 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip 
            formatter={(value) => {
              // Check if value is a number before using toFixed
              if (typeof value === 'number') {
                return [`$${value.toFixed(2)}`, 'Amount'];
              }
              return [value, 'Amount'];
            }} 
          />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RevenueSplitChart;
